/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiJobTaggerUniqueFieldFromJSON, ApiJobTaggerUniqueFieldToJSON, } from './ApiJobTaggerUniqueField';
import { ApiLocationFromJSON, ApiLocationToJSON, } from './ApiLocation';
import { ApiProjectFromJSON, ApiProjectToJSON, } from './ApiProject';
export function ApiJobTaggerFromJSON(json) {
    return ApiJobTaggerFromJSONTyped(json, false);
}
export function ApiJobTaggerFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'categorySelector': !exists(json, 'categorySelector') ? undefined : json['categorySelector'],
        'contractTypeSelector': !exists(json, 'contractTypeSelector') ? undefined : json['contractTypeSelector'],
        'descriptionSelector': !exists(json, 'descriptionSelector') ? undefined : json['descriptionSelector'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'idSelector': !exists(json, 'idSelector') ? undefined : json['idSelector'],
        'location': !exists(json, 'location') ? undefined : ApiLocationFromJSON(json['location']),
        'locationId': !exists(json, 'locationId') ? undefined : json['locationId'],
        'locationSelector': !exists(json, 'locationSelector') ? undefined : json['locationSelector'],
        'project': !exists(json, 'project') ? undefined : ApiProjectFromJSON(json['project']),
        'projectId': !exists(json, 'projectId') ? undefined : json['projectId'],
        'salaryRangeSelector': !exists(json, 'salaryRangeSelector') ? undefined : json['salaryRangeSelector'],
        'titleSelector': !exists(json, 'titleSelector') ? undefined : json['titleSelector'],
        'uniqueField': !exists(json, 'uniqueField') ? undefined : ApiJobTaggerUniqueFieldFromJSON(json['uniqueField']),
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (new Date(json['updatedAt'])),
    };
}
export function ApiJobTaggerToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'categorySelector': value.categorySelector,
        'contractTypeSelector': value.contractTypeSelector,
        'descriptionSelector': value.descriptionSelector,
        'id': value.id,
        'idSelector': value.idSelector,
        'location': ApiLocationToJSON(value.location),
        'locationId': value.locationId,
        'locationSelector': value.locationSelector,
        'project': ApiProjectToJSON(value.project),
        'projectId': value.projectId,
        'salaryRangeSelector': value.salaryRangeSelector,
        'titleSelector': value.titleSelector,
        'uniqueField': ApiJobTaggerUniqueFieldToJSON(value.uniqueField),
        'updatedAt': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
    };
}
